export default __webpack_public_path__ + "static/hctv-6546a573225a5ec5440f07a9387da2f4.jpg";